import { Dialog, useTheme } from '@mui/material';
import { AppTheme } from '../../../theme';




function DialogApp(props: any) {
    const theme: AppTheme = useTheme();

    return (
        <Dialog
            {...props}
            slotProps={{
                backdrop: {
                    sx:{
                        backgroundColor: theme.palette.shadowBackground,
                    }
                },
                paper:{
                    sx: { 
                        borderRadius: "25px",
                        backgroundColor: theme.palette.neutral_5
                    } 
                }
            }}
        />
    )
}

export default DialogApp;
